import type { fabric } from 'fabric';
import React, { useCallback } from 'react';
import { isMultiMatchTemplateType } from 'modules/manager/domain/placeholder/placeholder-key-registry';
import type { ObjectInspectorProps } from '../types';
import CommitOptionalNumberField from './commit-optional-number-field';
import HelpBubble from './help-bubble';
import InspectorRow from './inspector-row';
import InspectorSection from './inspector-section';
import { useCommonFabricData } from './use-common-fabric-data';

const MatchFilterSection: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const matchNumber = useCommonFabricData<number>(objects, 'matchNumber', editor);
  const templateType = editor.placeholders?.getTemplateType();

  const refitPlaceholders = useCallback(() => {
    const facade = editor.placeholders;
    if (!facade) return;
    for (const obj of objects) {
      if (facade.isPlaceholder(obj)) facade.refit(obj as fabric.Group);
    }
  }, [editor, objects]);

  if (!isMultiMatchTemplateType(templateType) || objects.length === 0) return null;

  return (
    <InspectorSection title="Фильтрация по матчу">
      <InspectorRow label="Матч №">
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, width: '100%', minWidth: 0 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <CommitOptionalNumberField
              value={matchNumber.isMixed ? undefined : matchNumber.value}
              placeholder={matchNumber.isMixed ? '(разное)' : '—'}
              min={1}
              onCommit={(v) => {
                matchNumber.setValue(v);
                refitPlaceholders();
              }}
            />
          </div>
          <HelpBubble
            content={
              <span>
                Скрывает каждый выбранный объект, если матч N не рендерится. <code>1</code> = первый матч
                из /render, <code>2</code> = второй и т.д. Используется только для мульти-матч шаблонов
                (например, «Несколько матчей»).
              </span>
            }
          />
        </div>
      </InspectorRow>
    </InspectorSection>
  );
};

export default MatchFilterSection;
